import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { ResetUserPassword } from 'src/app/shared/models/reset';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-profil',
  templateUrl: './profil.component.html',
  standalone: false,

  styleUrl: './profil.component.scss'
})

export class ProfilComponent {

  InfosUser: any = {}
  reference: any = [];
  resetItem: ResetUserPassword = new ResetUserPassword();
  constructor(

    private localstorage: LocalStorageService,
    private authService: AuthService,

    private messageService: MessageService,
    private router: Router,
    private ngxloader: NgxUiLoaderService,
  ) { }

  ngOnInit() {

    this.InfosUser = this.localstorage.getUsers().data;
    this.resetItem.user_reference  =this.InfosUser?.reference;
    this.resetItem.email =this.InfosUser?.email;
    console.log("les infos de l'utilisateur", this.InfosUser);

  }

  resetPassword() {
    //console.log("appele");

    if (!this.resetItem.canSave()) {

      this.messageService.add({ severity: 'error', summary: 'KondoCV', detail: this.resetItem.getErrorMessage() });
    }
    if (this.resetItem.canSave()) {
        this.ngxloader.start();
      this.authService.updatePasswordByReference(this.resetItem).subscribe(
        (response) => {
          //console.log("la reponse du webservice", response);
          if (response.status === "success") {
            this.messageService.add({ severity: 'success', summary: 'KondoCV', detail: response.message });
            this.router.navigate(['/'])
          }
          if (response.status === "error") {
          this.messageService.add({ severity: 'error', summary: 'KondoCV', detail: response.message });
          }
          this.ngxloader.stop();

        },
        (error) => {
          //console.log("une erreur est survenu", error);
          this.messageService.add({ severity: 'error', summary: 'KondoCV', detail: "une erreur est survenu" });
          this.ngxloader.stop();

        }

      )
    }

  }
  goToDash(){
    this.router.navigate(['ikena']);
  }

}